import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_37zwj76fpy: FaireBrandEntity = {
  token: "b_37zwj76fpy",
  type: "brand",
  name: "Witchwood Bags",
  avatarUrl:
    "https://cdn.faire.com/fastly/50f0aa99d32fa74526e5add0c5d04ccdad64aa475dffe104fb4f96960b44bfec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/396d85ff3cdfe35bdb7ec511613c9904a1f19c67a9c051d353227b4f738863fe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/50f0aa99d32fa74526e5add0c5d04ccdad64aa475dffe104fb4f96960b44bfec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/396d85ff3cdfe35bdb7ec511613c9904a1f19c67a9c051d353227b4f738863fe.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 59,
  isInsider: true,
  description:
    "Witchwood is a queer, one woman, run small business. Molly is the owner/designer/maker/artist/marketer/customer service/you-name-it! Molly has a studio in both sunny southern California and dreary Portland, Oregon and splits her time between both to give her different perspectives and inspiration throughout the year. \n\nAll items are all vegan and hand printed individually. Witchwood is always putting out new designs, so please check back frequently!\n\nWitchwood now has a retail location at 2236 NE Broadway, Portland, OR 97232!\n\nMolly broke into the fashion world in 2009 with her very own vintage clothing store, that she still runs til this day (in addition to Witchwood). Her hobbies include strolling through cemeteries after a fresh rain, taking care of her special needs furry children, expressing her experiences through tattoos and pretending she isn't as awkward as she really is. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:12.826Z",
    importedBy: "entity-db-cli",
  },
};
